<template>
  <Dialog
    v-model:visible="mostrarModal"
    :style="{ width: '450px' }"
    header="DATOS DE CLIENTE A FACTURAR"
    :modal="true"
    class="p-fluid"
    @hide="ocultarDialog"
  >
    <div class="col-12">
      <div class="p-fluid formgrid grid">
        <div class="field col-12 md:col-12">
          <strong>RAZ&Oacute;N SOCIAL: </strong>
          <span class="p-invalid">*</span>
          <InputText
            v-model.trim="data_cliente_factura.nombre"
            v-uppercase
            required="true"
            autofocus
          />
          <small class="p-invalid" v-if="errors.nombre">{{
            errors.nombre[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-6">
          <strong>TIPO DOCUMENTO: </strong>
          <Dropdown
            v-model="tipo_documento_selected"
            :options="tipos_documentos"
            optionLabel="label"
            placeholder="Seleccione tipo documento..."
          >
          </Dropdown>
        </div>
        <div class="field col-12 md:col-4">
          <strong>CI/NIT: </strong>
          <div class="p-inputgroup">
            <InputText v-model="data_cliente_factura.ci_nit" />
            <Button
              icon="pi pi-search"
              class="p-button-info"
              v-tooltip.top="'Verificar CI/NIT en el SIN'"
              @click="buscarClientePorCiNit(data_cliente_factura.ci_nit)"
              :loading="verificando_ci_nit"
            />
          </div>
          <small class="p-invalid" v-if="errors.ci_nit">{{
            errors.ci_nit[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-2">
          <strong>EXT. </strong>
          <InputText v-model="data_cliente_factura.complemento_documento" />
        </div>
        <div class="field col-12 md:col-8">
          <strong>CORREO ELECTR&Oacute;NICO: </strong>
          <InputText v-model="data_cliente_factura.correo" required="true" />
          <small class="p-invalid" v-if="errors.correo">{{
            errors.correo[0]
          }}</small>
        </div>
        <div class="field col-12 md:col-4">
          <strong>ESTADO: </strong><span class="p-invalid">*</span>
          <Dropdown
            v-model="data_cliente_factura.estado"
            :disabled="!data_cliente_factura.id"
            :options="estados"
            optionLabel="label"
            placeholder="Seleccione un estado..."
          >
            <template #value="slotProps">
              <span
                :class="'product-badge ' + claseEstado[slotProps.value.value]"
              >
                {{ slotProps.value.label }}
              </span>
            </template>
          </Dropdown>
        </div>
      </div>
    </div>
    <template #footer>
      <div class="field">
        <label class="flex md:justify-content-start"
          ><strong>CAMPOS REQUERIDOS: </strong>
          <span class="p-invalid">*</span></label
        >
      </div>
      <Button
        label="CANCELAR"
        icon="pi pi-times"
        class="p-button-secondary p-button-lg"
        @click="ocultarDialog"
      />
      <Button
        :label="data_cliente_factura.id ? 'ACTUALIZAR' : 'GUARDAR'"
        icon="pi pi-save"
        class="p-button-primary p-button-lg"
        @click="guardarClienteFactura"
        :loading="enviado"
      />
    </template>
  </Dialog>
</template>

<script>
import ClienteService from "@/service/ClienteService";
import TipoDocumentoIdentidadService from "@/service/TipoDocumentoIdentidadService";
export default {
  emits: ["closeModal", "actualizarListado"],
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    cliente_factura: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  clienteService: null,
  tipoDocumentoIdentidadService: null,
  data() {
    return {
      mostrarModal: this.show,
      data_cliente_factura: this.cliente_factura,
      tipo_documento_selected: {},
      enviado: false,
      errors: {},
      claseEstado: ["status-outofstock", "status-instock"],
      tipos_documentos: [],
      estados: [
        { label: "INACTIVO", value: 0 },
        { label: "ACTIVO", value: 1 },
        { label: "OBITADO", value: 2 },
      ],
      verificando_ci_nit: false,
    };
  },
  created() {
    this.clienteService = new ClienteService();
    this.tipoDocumentoIdentidadService = new TipoDocumentoIdentidadService();

    this.cargarTiposDocumentos();
  },
  methods: {
    esperarTiposDocumentos() {
      return new Promise((resolve) => {
        if (this.tipos_documentos.length > 0) {
          resolve();
          return;
        }

        const intervalo = setInterval(() => {
          if (this.tipos_documentos.length > 0) {
            clearInterval(intervalo);
            resolve();
          }
        }, 50);

        setTimeout(() => {
          clearInterval(intervalo);
          resolve();
        }, 2000);
      });
    },

    async detectarTipoDocumento(ci_nit) {
      await this.esperarTiposDocumentos();

      if (!ci_nit || !this.tipos_documentos.length) return;

      // Limpiar espacios y caracteres no numéricos
      const valor = ci_nit.toString().trim();

      // Solo detectar si es numérico
      if (!/^\d+$/.test(valor)) {
        // Si no es numérico, dejar CI por defecto
        const tipoCi = this.tipos_documentos.find((item) => item.value == 1);
        if (tipoCi) {
          this.tipo_documento_selected = tipoCi;
        }
        return;
      }

      const digitos = valor.length;

      // Lógica de detección automática:
      if (digitos >= 5 && digitos <= 8) {
        // CI: 5-8 dígitos
        const tipoCi = this.tipos_documentos.find((item) => item.value == 1);
        if (tipoCi) {
          this.tipo_documento_selected = tipoCi;
          this.data_cliente_factura.tipo_documento = 1;
        }
      } else if (digitos >= 9) {
        // NIT: 9+ dígitos
        const tipoNit = this.tipos_documentos.find((item) => item.value == 5);
        if (tipoNit) {
          this.tipo_documento_selected = tipoNit;
          this.data_cliente_factura.tipo_documento = 5;
        }
      } else {
        // Menos de 5 dígitos, dejar CI por defecto
        const tipoCi = this.tipos_documentos.find((item) => item.value == 1);
        if (tipoCi) {
          this.tipo_documento_selected = tipoCi;
          this.data_cliente_factura.tipo_documento = 1;
        }
      }
    },

    buscarClientePorCiNit(ci_nit) {
      let datos = { ci_nit };

      this.verificando_ci_nit = true;

      this.clienteService
        .getClienteFacturaPorCiNit(datos)
        .then((response) => {
          if (response.success) {
            // Detectar tipo automáticamente después de verificar
            this.detectarTipoDocumento(ci_nit);

            this.$toast.add({
              severity: "success",
              summary: "Éxito!",
              detail: response.mensaje,
              life: 9000,
            });
          } else {
            this.$toast.add({
              severity: "warn",
              summary: "Atención",
              detail: response.mensaje,
              life: 9000,
            });
          }

          this.verificando_ci_nit = false;
        })
        .catch((error) => {
          this.$toast.add({
            severity: "error",
            summary: "Error",
            detail: error,
            life: 9000,
          });

          this.verificando_ci_nit = false;
        });
    },

    cargarTiposDocumentos() {
      this.tipoDocumentoIdentidadService
        .getAllTipoDocumentoIdentidad()
        .then((data) => {
          data.forEach((element) => {
            if (
              this.data_cliente_factura.id &&
              this.data_cliente_factura.tipo_documento == element.id
            ) {
              this.tipo_documento_selected = {
                label: element.codigo + " - " + element.descripcion,
                value: element.id,
              };
            } else {
              if (element.id == 1) {
                this.tipo_documento_selected = {
                  label: element.codigo + " - " + element.descripcion,
                  value: element.id,
                };
              }
            }
            this.tipos_documentos.push({
              label: element.codigo + " - " + element.descripcion,
              value: element.id,
            });
          });
        });
    },

    ocultarDialog() {
      this.errors = {};
      this.mostrarModal = false;
      this.$emit("closeModal");
      this.enviado = false;
    },
    guardarClienteFactura() {
      this.errors = {};
      this.enviado = true;
      //editar cliente_factura
      if (this.cliente_factura.id) {
        let cliente_enviar = {
          ...this.data_cliente_factura,
          tipo_documento: this.tipo_documento_selected.value,
          estado: this.data_cliente_factura.estado.value,
        };
        this.clienteService
          .updatedClienteFactura(cliente_enviar)
          .then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 3000,
              });
              this.$emit("actualizarListado");
              this.ocultarDialog();
            }
            this.enviado = false;
          });
      } else {
        //CREANDO UN NUEVO PROVEEDOR
        let tmp = this.data_cliente_factura;
        this.data_cliente_factura = {
          ...this.data_cliente_factura,
          tipo_documento: this.tipo_documento_selected.value,
          estado: this.data_cliente_factura.estado.value,
        };
        this.clienteService
          .sendClienteFacturaNuevo(this.data_cliente_factura)
          .then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, "errors")) {
              this.errors = data.errors;
              this.data_cliente_factura = tmp;
            } else {
              this.errors = {};
              this.$toast.add({
                severity: "success",
                summary: "Exito!",
                detail: data.mensaje,
                life: 10000,
              });

              this.$emit("actualizarListado", data.cliente_factura);
              this.ocultarDialog();
            }
            this.enviado = false;
          });
      }
    },
  },
  watch: {
    show(val) {
      this.mostrarModal = val;
    },

    cliente_factura: {
      async handler(val) {
        this.data_cliente_factura = { ...val };

        // Detectar automáticamente tipo de documento
        await this.detectarTipoDocumento(val.ci_nit);

        // Si hay id (edición), establecer el tipo guardado
        if (val.id && val.tipo_documento) {
          const tipoDocumento = this.tipos_documentos.find(
            (item) => item.value == val.tipo_documento
          );
          if (tipoDocumento) {
            this.tipo_documento_selected = tipoDocumento;
          }
        }
      },
      immediate: true,
    },

    // Detectar mientras escribe
    "data_cliente_factura.ci_nit": {
      handler(nuevoValor) {
        if (nuevoValor && !this.data_cliente_factura.id) {
          this.detectarTipoDocumento(nuevoValor);
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/demo/badges.scss";
.p-invalid {
  color: red;
}
</style>
